import React from 'react'
import { AlertCircle, ArrowDownCircle } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { Container, Box, Chip, makeStyles } from '@material-ui/core'
import { BoreholeFieldUsageTableProps } from './BoreholeFieldUsageTable'
import { createConfirmationData } from '../../../borehole-field-container/borehole-field-data-creator'
import {
  BoreholeFieldContainerFragment,
  isConfirmationValid,
} from '../../../borehole-field-container/borehole-field-confirmation-validator'

const SPACING = 4

const useStyles = makeStyles((theme) => ({
  successContainer: {
    color: 'white',
    backgroundColor: `${theme.palette.success.main} !important`,
    '&:hover': {
      backgroundColor: theme.palette.success.main,
      filter: 'brightness(120%)',
    },
  },

  warningContainer: {
    color: 'white',
    backgroundColor: `${theme.palette.warning.main} !important`,
    '&:hover': {
      backgroundColor: theme.palette.warning.main,
      filter: 'brightness(120%)',
    },
  },
  chipIcon: {
    color: 'white',
  },
}))

type Props = BoreholeFieldUsageTableProps & {
  container: BoreholeFieldContainerFragment
  onWarningClick: () => void
}

export function BoreholeFieldWarning({
  container,
  harvested,
  wasteInput,
  onWarningClick,
}: Props): React.ReactElement {
  const classes = useStyles()
  const { t } = useTranslation()

  const currentBoreholeData = createConfirmationData(
    container,
    harvested,
    wasteInput,
  )

  if (isConfirmationValid(container, currentBoreholeData)) {
    return <></>
  }

  return (
    <Container>
      <Box py={SPACING}>
        <Chip
          className={classes.warningContainer}
          label={t('boreholeField.confirmationNecessaryWarning')}
          clickable
          onClick={onWarningClick}
          onDelete={onWarningClick}
          icon={<AlertCircle className={classes.chipIcon} />}
          deleteIcon={<ArrowDownCircle className={classes.chipIcon} />}
        />
      </Box>
    </Container>
  )
}
